import CONFIG from '../config/config';
import { tools } from './tools';

const getKey = () => {
  const array = tools.getCookie(CONFIG.KEY)?.split('%7C');
  return { key: array?.[0] ? array[0] : '', skey: array?.[1] ? array[1] : '' };
};

const setKey = (key, skey, day = 365) => {
  let str = '';
  if (key && skey && key !== '' && skey !== '') {
    str = `${key}|${skey}`;
  } else if (key && key !== '' && (!skey || skey === '')) {
    str = key;
  } else {
    return;
  }
  tools.setCookie(CONFIG.KEY, str, day);
};

const clearKey = () => {
  tools.setCookie(CONFIG.KEY, '', -1);
};
export { getKey, setKey, clearKey };
